export const PhoneMask = "099 999 99999";